import { LinkingOptions } from '@react-navigation/native';

const linking: LinkingOptions<any> = {
  prefixes: ['http://localhost:19007', 'http://localhost:3003', 'https://talents.adaadev.ae'],
  config: {
    // Stack rendered directly (no drawer wrapper) — paths keep the /talents prefix
    screens: {
      Talents: 'talents',
      SpecializationDetail: 'talents/specialization/:name',
      ProjectDetail: 'talents/project/:name',
      OutputGallery: 'talents/output/:name',
      StudentDetail: 'talents/student/:name',
      TalentActivityDetail: {
        path: 'talents/activity/:id',
        parse: { id: Number },
      },
      AddTalentActivity: {
        path: 'talents/activity/add',
        parse: {
          specializationId: Number,
          projectId: Number,
          activityId: Number,
        },
      },
      AddOutput: {
        path: 'talents/output/add',
        parse: { projectId: Number },
      },
      EditTeacher: {
        path: 'talents/teacher/edit',
        parse: { id: Number, specializationId: Number },
      },
      EditStudent: {
        path: 'talents/student/edit',
        parse: { id: Number, specializationId: Number },
      },
      AddProject: {
        path: 'talents/project/add',
        parse: { specializationId: Number, projectId: Number },
      },
      TeacherDetail: {
        path: 'talents/teacher/:id',
        parse: { id: Number },
      },
      EditTalents: 'talents/edit',
      AddTalentKPI: {
        path: 'talents/add-kpi',
        parse: {
          specializationId: Number,
          projectId: Number,
          activityId: Number,
          studentId: Number,
        },
      },
      TalentKPIDetail: {
        path: 'talents/kpi-detail/:kpiLinkId',
        parse: { kpiLinkId: Number },
      },
      AddTalentKPIReading: {
        path: 'talents/add-kpi-reading',
        parse: { kpiLinkId: Number },
      },
      StudentProfile: 'talents/my-profile',
      CoordinatorProfile: 'talents/coordinator-profile',
      StudentTalentRegister: 'talents/register-talent',
      Settings: 'talents/settings',
    },
  },
};

export default linking;
